import globals from "/utils/globals";

const enabled = (key, featureFlags = globals.featureFlags || {}) => {
  return featureFlags[key];
};

export default {
  enabled
};
